import $ from 'jquery';
import Masonry from 'isotope-layout';
import _ from 'lodash';
import FastAverageColor from 'fast-average-color';

export default {
  init() {

    $('.main-menu-burger, .close-menu-button').on('click', function(){
      $('.mobile-menu').toggleClass('active');
    });

    const scrollbarWidth = window.innerWidth - document.body.clientWidth;
    document.documentElement.style.setProperty("--scrollbarWidth", `${scrollbarWidth}px`);

    var elem = document.querySelector('.rooms-container');

    if(elem){
      var $grid = new Masonry(elem, {
        layoutMode: 'masonry',
        masonry: {
          columnWidth: '.grid-sizer',
          itemSelector: '.room-item',
          percentPosition: true,

        },
        //fitWidth: true,
      });
    }

    $('.inner-screen').each(function( index ) {
      let a = $(this).width();
      let b = $(this).height();
      let c = Math.sqrt(a*a + b*b);
      let bar_length = c;
      let ang = Math.acos(a/c);
      $(this).children('.bar').css("width", bar_length );
      $(this).children('.bar_1').css('transform', 'rotate('+ ang + 'rad) translateY(-6px)');
      $(this).children('.bar_2').css('transform', 'rotate(-'+ ang + 'rad) translateY(6px) scaleY(var( --scale, 1 )) translate3d(0, 0, 0)');
    });

    var debounceResize = _.debounce(function(){
      $('.inner-screen').each(function( index ) {
        let a = $(this).width();
        let b = $(this).height();      
        let c = Math.sqrt(a*a + b*b);
        let bar_length = c;
        let ang = Math.acos(a/c);
        $(this).children('.bar').css("width", bar_length );
        $(this).children('.bar_1').css('transform', 'rotate('+ ang + 'rad) translateY(-6px)');
        $(this).children('.bar_2').css('transform', 'rotate(-'+ ang + 'rad) translateY(6px) scaleY(var( --scale, 1 )) translate3d(0, 0, 0)');
      });
    }, 100);

    $(window).on('resize', debounceResize);


    $('.room').hover(
      function(){ $(this).addClass('hover') },
      function(){ $(this).removeClass('hover') }
    );

    let duration = parseInt(parseInt($('#statements_1').width()) / 50);
    var style = (function() {
      var style = document.createElement("style");
      style.appendChild(document.createTextNode(""));
      document.head.appendChild(style);
      return style;
  })();
    style.sheet.insertRule('.statements{animation: bannerSlide ' + duration + 's linear infinite;}', 0);

    const fac = new FastAverageColor();
    const container = document.querySelectorAll('.rueckblick-image-wrapper');

    if(container.length){
      container.forEach( el => {
        fac.getColorAsync(el.querySelector('img'))
        .then(color => {
            el.querySelector('.rueckblick-image-screen').style.backgroundColor = color.rgba;
            el.style.backgroundColor = color.rgba;
        })
        .catch(e => {
            console.log(e);
        });
      }
      );
    }


    function shuffle(array) {
      var m = array.length, t, i;
    
      // While there remain elements to shuffle…
      while (m) {
    
        // Pick a remaining element…
        i = Math.floor(Math.random() * m--);
    
        // And swap it with the current element.
        t = array[m];
        array[m] = array[i];
        array[i] = t;
      }
    
      return array;
    }

    $( '.rueckblick' ).on({
      mouseenter: function () {
      },
      mouseleave: function () {
        var item_1 = shuffle($(".rueckblick")).slice(0, 1);
        var item_1_clone = item_1.clone(true);
        var item_2 = $(this).clone(true);
        $(this).replaceWith(item_1_clone);
        item_1.replaceWith(item_2);
      }
    });

    $(document).on('keyup', function(event) {
      if (event.key == "Escape") {
        $('.mobile-menu').removeClass('active');
      }
    });

    let rooms_container_element = $('#rooms-container');
    if(rooms_container_element.length > 0){
      let animation_number = Math.floor((Math.random() * 6) + 1);
      rooms_container_element.addClass('room-animation-' + animation_number);
    }

    if(!cb_script_vars.img_right_active){
      $('body').on('contextmenu', 'img', function(e){ 
        return false;
      });
      $('body').on('dragstart', 'img', function(e){
        e.preventDefault();
        return false;
      });
    }


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
